export const ltiConstants = {
  FETCH_LTI_CONFIGURATIONS_REQUEST: 'FETCH_LTI_CONFIGURATIONS_REQUEST',
  FETCH_LTI_CONFIGURATIONS_SUCCESS: 'FETCH_LTI_CONFIGURATIONS_SUCCESS',
  FETCH_LTI_CONFIGURATIONS_FAILURE: 'FETCH_LTI_CONFIGURATIONS_FAILURE'
};

const fetchLtiConfigurationsRequest = () => {
  return {
    type: ltiConstants.FETCH_LTI_CONFIGURATIONS_REQUEST
  };
};

const fetchLtiConfigurationsSuccess = (configurations) => {
  return {
    type: ltiConstants.FETCH_LTI_CONFIGURATIONS_SUCCESS,
    payload: configurations
  };
};

const fetchLtiConfigurationsFailure = (error) => {
  return {
    type: ltiConstants.FETCH_LTI_CONFIGURATIONS_FAILURE,
    error
  };
};

export const ltiDispatches = {
  fetchLtiConfigurationsRequest,
  fetchLtiConfigurationsSuccess,
  fetchLtiConfigurationsFailure
};

const commonVariables = {
  version: 'version',
  editMode: 'edit_mode',
  name: 'name',
  description: 'description'
};

export const lti1p1Variables = {
  ...commonVariables,
  ltiUrl: 'lti_1p1_launch_url',
  clientKey: 'lti_1p1_client_key',
  clientSecret: 'lti_1p1_client_secret'
};

export const lti1p3Variables = {
  ...commonVariables,
  clientId: 'lti_1p3_client_id',
  deploymentId: 'lti_1p3_deployment_id',
  toolLaunchUrl: 'lti_1p3_launch_url',
  loginUrl: 'lti_1p3_oidc_url',
  publicKey: 'lti_1p3_tool_public_key',
  keysetUrl: 'lti_1p3_tool_keyset_url',
  privateKey: 'lti_1p3_private_key',
  redirectUris: 'lti_1p3_redirect_uris',
  enableNrps: 'lti_advantage_enable_nrps',
  enableDeepLinking: 'lti_advantage_deep_linking_enabled',
  deepLinkingLaunchUrl: 'lti_advantage_deep_linking_launch_url',
  agsMode: 'lti_advantage_ags_mode'
};

export const inputFieldsLTI1p1 = [
  {
    name: 'name',
    label: 'Configuration Name',
    type: 'text',
    placeholder: 'e.g., My LTI Tool',
    helptext: 'A descriptive name for this LTI configuration.',
    required: true
  },
  {
    name: 'ltiUrl',
    label: 'LTI URL',
    type: 'text',
    placeholder: 'https://example/launch',
    helptext: 'The URL of the external tool that initiates the launch.'
  },
  {
    name: 'clientKey',
    label: 'LTI Client ID',
    type: 'text',
    placeholder: '',
    helptext: 'Client key provided by the LTI tool provider.'
  },
  {
    name: 'clientSecret',
    label: 'LTI Client Secret',
    placeholder: '',
    helptext: 'Client secret provided by the LTI tool provider.'
  }
];

export const inputFieldsLTI1p3 = [
  {
    name: 'name',
    label: 'Configuration Name',
    type: 'text',
    placeholder: 'e.g., My LTI Tool',
    helptext: 'A descriptive name for this LTI configuration.',
    required: true
  },
  {
    name: 'toolLaunchUrl',
    label: 'Tool Launch URL',
    type: 'text',
    placeholder: 'https://example/launch',
    helptext: 'The LTI launch URL, otherwise known as the target_link_uri.',
    required: true
  },
  {
    name: 'loginUrl',
    label: 'Tool Initiate Login URL (OIDC URL)',
    type: 'text',
    placeholder: 'https://example/login',
    helptext: 'This is the OIDC third-party initiated login endpoint URL.',
    required: true
  },
  {
    name: 'publicKey',
    label: 'Tool Public Key',
    type: 'textarea',
    placeholder: '',
    helptext: 'Please enter either a public key or a keyset URL.',
    required: true
  },
  {
    name: 'keysetUrl',
    label: 'Tool Keyset URL',
    type: 'text',
    placeholder: 'https://example.json',
    helptext: 'Please enter either a public key or a keyset URL.'
  },
  {
    name: 'privateKey',
    label: 'Platform Private Key',
    type: 'textarea',
    placeholder: 'Enter RSA private key in PEM format (required for communication with the provider tool)',
    helptext: 'Platform private key in PEM format. Required for secure communication with the provider tool.',
    required: true
  },
  {
    name: 'redirectUris',
    label: 'Redirect URIs',
    type: 'textarea',
    placeholder: '["https://example.com/launch"]',
    helptext: 'Valid redirect URIs as JSON array. Often same as launch URL.'
  },
  {
    name: 'enableDeepLinking',
    label: 'Enable Deep Linking',
    type: 'checkbox',
    helptext: 'Enable LTI Advantage Deep Linking. Requires a valid Deep Linking Launch URL below.'
  },
  {
    name: 'deepLinkingLaunchUrl',
    label: 'Deep Linking Launch URL',
    type: 'text',
    placeholder: 'https://example/deep_linking',
    helptext: 'The URL the tool uses for deep linking. Required when deep linking is enabled.'
  },
  {
    name: 'enableNrps',
    label: 'Enable Names and Role Provisioning',
    type: 'checkbox',
    helptext: 'Enable LTI Advantage Names and Role Provisioning Services.'
  },
  {
    name: 'agsMode',
    label: 'Assignment and Grade Services Mode',
    type: 'select',
    options: [
      { value: 'disabled', label: 'Disabled' },
      { value: 'declarative', label: 'Declarative (default)' },
      { value: 'programmatic', label: 'Programmatic' }
    ],
    helptext: 'Select the AGS functionality level for LTI tools.'
  }
];
